<template>
  <div class="createBook-container app-container">
    <tabHeader :slideData="slideData" :tab="tab" @headerTabBack="headerTabBack">
      <div class="createBook-btn">
        <button class="global-button-style" @click="save" v-show="play">
          {{ $t("commonMsg.save") }}
        </button>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
      </div>
    </tabHeader>
    <transition name="fade" mode="out-in">
      <component
        :is="tab"
        :ref="tab"
        @isLogFn="isLogFn"
        @bookHandle="bookHandle"
        :booksId="booksId"
      ></component>
    </transition>
    <!-- <transition-group class="createBook-content" name="fade">
            <bookInfo
            ref="bookInfo"
            v-show="tab==='info'"
            key="info"
            />
            <bookDirectory
                ref="bookDirectory"
                v-show="tab!=='info'"
                
                key="directory"/>
        </transition-group> -->
  </div>
</template>

<script>
import tabHeader from "@/components/tabHeader";
import info from "./components/info";
import directory from "./components/directory";
export default {
  components: {
    tabHeader,
    info,
    directory
  },
  computed: {
    slideData() {
      let slideData = [
        {
          name: this.$t("content.books.basic"),
          component: "info"
        },
        {
          name: this.$t("content.books.chapter"),
          component: "directory"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: "info",
      play: true,
      booksId: ""
    };
  },
  methods: {
    headerTabBack(tab) {
      this.play = !this.play; //取反
      this.tab = tab.component;
    },
    save() {
      this.$refs.info.submit();
    },
    bookHandle(form) {
      for (let key in form) {
        form[key] === null ? delete form[key] : "";
      }
      this.$http.updateBook(form._id, form).then(res => {
        this.elMsg(this.$t("alertMsg.releaseSuccess"), "success");
      });
    },
    isLogFn(dataId) {
      this.booksId = dataId;
    }
  }
};
</script>

<style lang="scss" scoped>
.createBook-content {
  flex: 1;
  position: relative;
}
.createBook-btn {
  display: flex;
}
</style>
